"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modifiers = exports.EAdaptMode = void 0;
const Adapt_1 = require("./Adapt");
const Mirror_1 = require("./Mirror");
const Smooth_1 = require("./Smooth");
const Solidify_1 = require("./Solidify");
const Subdivide_1 = require("./Subdivide");
const Close_1 = require("./Close");
const Offset_1 = require("./Offset");
var Adapt_2 = require("./Adapt");
Object.defineProperty(exports, "EAdaptMode", { enumerable: true, get: function () { return Adapt_2.EAdaptMode; } });
const Modifiers = {
    Adapt: Adapt_1.Adapt,
    Mirror: Mirror_1.Mirror,
    Smooth: Smooth_1.Smooth,
    Solidify: Solidify_1.Solidify,
    Subdivide: Subdivide_1.Subdivide,
    Close: Close_1.Close,
    Offset: Offset_1.Offset,
};
exports.Modifiers = Modifiers;
//# sourceMappingURL=index.js.map